exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".create-account-dialog {\n  min-width: 400px;\n}\n\n.create-account-dialog md-form-field {\n  width: 100%;\n  display: block;\n  margin-bottom: 10px;\n}\n\n.create-account-dialog md-dialog-content {\n  padding: 20px;\n}\n\n.create-account-dialog md-dialog-actions {\n  padding: 10px 20px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/finance/bank-statements-batch/create-account-dialog/create-account-dialog.component.css
// module id = 2004
// module chunks = 0